export enum RouteNames {
  Crossroad = 'Crossroad',
  LoanValue = 'LoanValue',
  PersonData = 'PersonData',
  Banking= 'Banking',
  Cover = 'Cover',
  Documents = 'Documents',
  NotFound = 'NotFound'
}
